var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
const u = up.util;
up.Change.FromURL = (_a = class FromURL extends up.Change {
        execute() {
            return __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                let newPageReason = this._newPageReason();
                if (newPageReason) {
                    up.puts('up.render()', newPageReason);
                    up.network.loadPage(this.options);
                    return u.unresolvablePromise();
                }
                let requestAttrs = this._getRequestAttrs();
                let request = this.request = up.request(requestAttrs);
                (_c = (_b = this.options).onRequestKnown) === null || _c === void 0 ? void 0 : _c.call(_b, request);
                if (this.options.preload)
                    return request;
                this.options.handleAbort(Object.assign({ request }, requestAttrs));
                request.runPreviews(this.options);
                return yield u.always(request, (responseOrError) => this._onRequestSettled(responseOrError));
            });
        }
        _newPageReason() {
            if (u.isCrossOrigin(this.options.url)) {
                return 'Loading cross-origin content in new page';
            }
            if (this.options.history && !up.browser.canPushState()) {
                return 'Loading content in new page to restore history support';
            }
        }
        _getRequestAttrs() {
            const successAttrs = this._preflightPropsForRenderOptions(this.options);
            const failAttrs = this._preflightPropsForRenderOptions(this.deriveFailOptions(), { optional: true });
            return Object.assign(Object.assign(Object.assign({}, this.options), successAttrs), u.withRenamedKeys(failAttrs, up.fragment.failKey));
        }
        getPreflightProps() {
            return this._getRequestAttrs();
        }
        _preflightPropsForRenderOptions(renderOptions, getPreflightPropsOptions) {
            const preflightChange = new up.Change.FromContent(Object.assign(Object.assign({}, renderOptions), { preflight: true }));
            return preflightChange.getPreflightProps(getPreflightPropsOptions);
        }
        _onRequestSettled(response) {
            if (response instanceof up.Response) {
                return this._onRequestSettledWithResponse(response);
            }
            else {
                return this._onRequestSettledWithError(response);
            }
        }
        _onRequestSettledWithResponse(response) {
            return new up.Change.FromResponse(Object.assign(Object.assign({}, this.options), { response })).execute();
        }
        _onRequestSettledWithError(error) {
            if (error instanceof up.Offline) {
                let log = ['Cannot load fragment from %s: %s', error.request.description, error.reason];
                this.request.emit('up:fragment:offline', {
                    callback: this.options.onOffline,
                    renderOptions: this.options,
                    retry: (retryOptions) => up.render(Object.assign(Object.assign({}, this.options), retryOptions)),
                    log,
                });
            }
            throw error;
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _getRequestAttrs: true,
        });
    })(),
    _a);
